<template>
  <div id="app" :class="[device, {'magento': isMagento }, generator]">
    <router-view></router-view>
    <popup-tooltip v-if="activeTooltip !== null"
                   @close="activeTooltip = null"
                   :tooltip-content="activeTooltip"
    ></popup-tooltip>
    <popup-trigger-share
        v-if="showSharePopup"
    ></popup-trigger-share>
  </div>
</template>

<script>
import SelectionHeader from "./components/AppHeader";
import PopupTooltip from "@/components/popup/PopupTooltip";
import PopupTriggerShare from "@/components/popup/PopupTriggerShare";
import {mapGetters} from "vuex";
import {checkLocalStorageKey} from "@/helpers/localstorage";
import Popup from "@/components/popup/Popup.vue";

export default {
  name: 'App',
  components: {Popup, PopupTooltip, PopupTriggerShare, SelectionHeader},
  methods: {
    subscribeMutations() {
      this.$store.subscribe((mutation, state) => {
        const buildMutators = [
          'build/setMotor',
          'build/setPump',
          'build/setTank',
          'build/setValveType',
          'build/setCircuit',
          'build/setLid',
          'build/setElectricalBox',
          'build/setWheels',
          'build/setCooler',
          'build/setSelect',
          'build/valves/addValve',
          'build/valves/addAdditionalValve',
          'build/valves/updateValve',
          'build/valves/dropValves',
          'build/valves/updateAdditionalValve',
          'build/valves/removeValve',
          'preference/updateLiters',
          'preference/updatePressure',
          'preference/updatePower',
          'preference/updateSafetyPressure',
          'preference/setMotorOption',
          'powerpackOptions/setSelected',
          'openFrameOptions/setSelected',
        ];
        if (buildMutators.includes(mutation.type) && !state.build.loading) {
          this.$store.dispatch('build/saveBuild');
        }
      });
    },
    setResponsiveDevice() {
      const width = window.outerWidth;
      let device;
      if (width > 1024) {
        device = 'desktop';
      } else if (width > 840) {
        device = 'tablet';
      } else if (width < 840) {
        device = 'mobile';
      }
      this.$store.dispatch('setDevice', device);
    },
    pushUserToRoute() {
      const fullPath = this.$route.fullPath;
      const params = {};
      let changeUrl = true;

      const urlParts = fullPath.split('/');
      if (typeof urlParts.at(2) === 'string') {
        params.uid = urlParts.at(2);
      }

      if (this.generator) {
        switch (this.generator) {
          case 'powerpack_motor':
            if (this.$route.name !== 'powerpack-motor-configurator') this.$router.push('/powerpack-motor-configurator')
            break;
          case 'powerpack':
            if (this.$route.name !== 'powerpack-configurator') {
              this.$router.push({
                name: this.isMagento ? 'powerpack-generator' : 'powerpack-configurator',
                params,
              })
            }
            break;
          case 'cylinder':
            if (this.$route.name !== 'cilinder-configurator') this.$router.push('/cilinder-configurator')
            break;
          case 'hose':
            if (this.$route.name !== 'slang-configurator') this.$router.push({
              name: 'slang-configurator',
              params,
            })
            break;
          case 'motor':
            if (this.$route.name !== 'motor-configurator') this.$router.push({
              name: 'motor-configurator',
              params
            })
            break;
          default:
            changeUrl = false;
        }

        if (changeUrl) {
          window.history.pushState(this.page, '', fullPath);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isMagento: 'preference/isMagento',
      generator: 'preference/getGenerator',
      urlSlug: 'preference/getUrlSlug',
    }),
    device() {
      return this.$store.getters.getDevice;
    },
    activeTooltip: {
      get() {
        return this.$store.getters['tooltips/getActiveTooltip'];
      },
      set(val) {
        this.$store.commit('tooltips/setCurrentActive', val)
      }
    },
    showSharePopup: {
      get() {
        return this.$store.state['share'].open;
      },
    },
  },
  async created() {
    await this.$store.commit('cart/init');
    await this.$store.dispatch('initAll');
    this.$store.commit('preference/finishedLoading');
    if (this.$route.params.uid === undefined) {
      await this.$store.dispatch('build/hoses/setFirstHose');
      await this.$store.dispatch('build/hoses/setFirstAvailableCoupling');
    }
    this.subscribeMutations();

    window.addEventListener("resize", this.setResponsiveDevice);
    this.setResponsiveDevice();
  },
  mounted() {
    this.pushUserToRoute();
    checkLocalStorageKey();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setResponsiveDevice);
  },
};
</script>

<style lang="scss">
#app {
  font-family: neue-haas-grotesk-text, sans-serif;
  font-weight: 400;
  font-style: normal;
  background-color: #F5F5F5;

  @media only screen and (max-width: 768px) {
    background-color: white;
  }

  .btn.btn-primary {
    background: #3DB0C7;
    border-color: darken(#3DB0C7, 2%);
    border-radius: 19px;
    padding-left: 20px;
    padding-right: 20px;

    &:hover {
      background: darken(#3DB0C7, 5%);
      border-color: darken(#3DB0C7, 2%);
    }
  }
}

.form-control {
  z-index: 1!important;
}

.checkbox {
  margin: 0!important;
}

.ps-content {
  background-color: #F5F5F5;
}

.ps-pagetitle, .ps-breadcrumbs {
  display: none;
}

.container {
  max-width: 1630px !important;
}

.tooltip {
  white-space: pre-line;
  opacity: 1 !important;

  .tooltip-inner {
    text-align: left;
  }
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #3DB0C7;
  border-radius: 10px;
}

canvas {
  transition: all ease 0.8s 0.1s;
  opacity: 1;
}

canvas.to-cart {
  opacity: 0;
  top: 0 !important;
  left: 100vw !important;
  transform-origin: top right;
  transform: translateX(-100%) scale(0.1);
  z-index: 99999;

  @media only screen and (min-width: 1460px) {
    transform: translateX(-100%) translateX(calc(-5vw)) scale(0.1);
  }

  @media only screen and (max-width: 900px) {
    transform: translateX(-100%) scale(0.1);
  }
}

body {
  .switcher-language {
    font-size: 1.4rem;
  }

  button.subscribe {
    line-height: 1.6rem;
  }

  #maincontent {
    max-width: 1430px !important;
  }

  #app.magento {
    background-color: #FFF;
    min-height: 85vh;

    &.cylinder,
    &.motor {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .container {
      max-width: 1430px !important;
    }

    .card {
      font-size: 1.4rem;

      .btn {
        font-size: 1.4rem;
      }
    }

    .btn {
      font-size: 1.2rem;
    }
  }

  .btn.LiveSearch-ShowMore {
    background: #00B900;
    font-size: 16px;
    border: none;
    border-radius: 10px;
  }
}
</style>
